import React from 'react';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

const types = ['', 'SID', 'TWEEN'];

class TypeByConstruction extends React.Component {
    render() {
        const {
            getError, changeField, confirmed, type, modifiedFields, underStyle, 
        } = this.props;

        return (
            <SelectField
                value={type}
                disabled={confirmed}
                onChange={(e, index, value) => {
                    changeField({
                        field: 'typeByConstruction',
                        value,
                    });
                }}
                maxHeight={200}
                name='typeByConstruction'
                floatingLabelText='Type By Construction'
                errorText={getError && getError('typeByConstruction')}
                fullWidth

                underlineStyle={modifiedFields && modifiedFields.includes('typeByConstruction') ? underStyle : null}
            >
                {
                    types.map((t, i) => (<MenuItem
                        key={`${t}_${i}`}
                        value={t}
                        primaryText={t}
                    />))
                }
            </SelectField>
        );
    }
}

export default TypeByConstruction;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/TypeByConstruction.jsx